export default "__VITE_ASSET__C9UVbXa3__"